"use client";

import React from "react";
import { useSearchFocus } from "@/app/context";
import { useTranslations } from "next-intl";

const AirlinesSection = () => {
  const { focusInput } = useSearchFocus();
  const t = useTranslations("HomePageFlights.AirlinesSection");

  const airlines = [
    {
      name: "CebuPacific",
      image: "/assets/v2/images/Airlines/CebuPacific.png",
      left: 221,
      top: 120,
    },
    {
      name: "Emirates",
      image: "/assets/v2/images/Airlines/Emirates.png",
      left: 321,
      top: 80,
    },
    {
      name: "KLM",
      image: "/assets/v2/images/Airlines/KLM.png",
      left: 121,
      top: 80,
    },
    {
      name: "AmericanAirlines",
      image: "/assets/v2/images/Airlines/AmericanAirlines.png",
      left: 121,
      top: 187,
    },
    {
      name: "British Airways",
      image: "/assets/v2/images/Airlines/BritishAirways.png",
      left: 321,
      top: 187,
    },
    {
      name: "EasyJet",
      image: "/assets/v2/images/Airlines/EasyJet.png",
      left: 221,
      top: 227,
    },
    {
      name: "Wizz",
      image: "/assets/v2/images/Airlines/Wizz.png",
      left: 121,
      top: 294,
    },
    {
      name: "QatarAirways",
      image: "/assets/v2/images/Airlines/QatarAirways.png",
      left: 321,
      top: 294,
    },
    {
      name: "United",
      image: "/assets/v2/images/Airlines/Delta.png",
      left: 221,
      top: 334,
    },
  ];

  return (
    <section className="w-full py-8 bg-white dark:bg-dark text-black dark:text-white rounded-xl dark:rounded-none m-0 md:py-16">
      <div className="container max-w-[1200px] mx-auto flex flex-col items-center gap-6 px-4 md:flex-row md:gap-12">
        {/* --- Left Section: Airlines grid --- */}
        <div className="w-full max-w-[522px] h-[454.91px] bg-gradient-to-b from-[#D1F4FD] to-[rgba(210,245,255,0)] dark:bg-gradient-to-b dark:from-violet-400/80 dark:to-indigo-200/0 rounded-[41.46px] mx-auto md:mx-0 p-4 relative">
          {/* Mobile grid */}
          <div className="md:hidden grid grid-cols-3 gap-1 place-items-center h-full">
            {airlines.map((a, i) => (
              <div
                key={i}
                className={`w-14 h-14 bg-white rounded-[8px] flex items-center justify-center ${i >= 3 && i <= 5 ? "mt-2" : ""}`}
              >
                <img
                  className="w-12 h-auto max-h-[40px]"
                  src={a.image}
                  alt={`${a.name} logo`}
                />
              </div>
            ))}
          </div>

          {/* Desktop absolute layout */}
          <div className="hidden md:block h-full">
            {airlines.map((a, i) => (
              <div
                key={i}
                className="absolute w-20 h-20 bg-white rounded-[10px] flex items-center justify-center"
                style={{
                  left: `min(${a.left}px, calc(100% - 80px))`,
                  top: `${a.top}px`,
                }}
              >
                <img
                  className="w-18 h-auto max-h-[64px]"
                  src={a.image}
                  alt={`${a.name} logo`}
                />
              </div>
            ))}
          </div>
        </div>

        {/* --- Right Section: Text + Button --- */}
        <div className="flex flex-col items-center gap-8 max-w-[409.74px] mx-auto">
          <div className="text-center text-[32px] font-semibold leading-[42px] font-inter text-black dark:text-white md:text-[40px] md:leading-[52px]">
            {t("title.part1")} <br />
            <span className="bg-gradient-to-b from-[#42E6FF] to-[#8B5EF7] bg-clip-text text-transparent">
              {t("title.highlight")}
            </span>
          </div>

          <p className="text-center text-base font-normal leading-6 font-inter max-w-[306.68px] text-black dark:text-gray-300 md:text-lg md:leading-7">
            {t("description")}
          </p>

          <button
            className="w-60 h-12 px-6 py-2.5 bg-gradient-to-br from-cyan-300 to-violet-500 rounded-lg inline-flex justify-center items-center gap-1 text-white text-sm font-semibold font-inter leading-tight mx-auto"
            onClick={() => focusInput("From")}
          >
            {t("button")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default AirlinesSection;
